module.exports = __webpack_public_path__ + "static/media/tipfg.a6208252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tipfg.png
// module id = 445
// module chunks = 0